import {
    GET_SUBSCRIPTIONS_FROM_USER,
    UPDATE_SUBSCRIPTION
} from '../../Actions/EndUser/SubscriptionActions';

const initialState = {
	subscriptions: [],
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_SUBSCRIPTIONS_FROM_USER:
			return {
				...state,
				loading: true,
				subscriptions: action.payload
            };
		case UPDATE_SUBSCRIPTION:
			return {
				...state,
				subscriptions: action.payload
			};
		default:
			return state;
	}
};
